import { C } from '@/lib/constants';

interface PencilIconProps {
  size?: number;
  color?: string;
}

export function PencilIcon({ size = 14, color: c }: PencilIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className="block">
      <path d="M11.5 1.5l3 3-9 9H2.5v-3l9-9z" stroke={c || C.mid} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M9.5 3.5l3 3" stroke={c || C.mid} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}
